import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// const perfix = 'http://192.168.2.82:8090/erp' // 服务名
const perfix = '/erp' // 服务名

// 获取预览模板链接
export const getPreviewTemplateLink = (data: any) =>
  request.post(
    perfix + '/retailContractTemplateManage/getPreviewTemplateLink',
    data,
    jsonHeaderConfig
  )

// 查询合同模板配置-分页数据
export const getTemplateManagePage = (data: any) =>
  request.post(
    perfix + '/retailContractTemplateManage/getTemplateManagePage',
    data,
    jsonHeaderConfig
  )

// 获取合同模板配置详情
export const getTemplateDetails = (data: any) =>
  request.post(perfix + '/retailContractTemplateManage/getTemplateDetails', data, jsonHeaderConfig)

// 刷新模板配置-三方返回结果
export const refreshTripartiteSettingResult = (data: any) =>
  request.post(
    perfix + '/retailContractTemplateManage/refreshTripartiteSettingResult',
    data,
    jsonHeaderConfig
  )

// 保存合同模板基础信息-新增、修改
export const saveTemplateManage = (data: any) =>
  request.post(perfix + '/retailContractTemplateManage/saveTemplateManage', data, {
    headers: { 'Content-Type': ContentTypeEnum.FORM_DATA }
  })

// 下一步、重新配置合同模板
export const settingTripartiteTemplateManage = (data: any) =>
  request.post(perfix + '/retailContractTemplateManage/settingTripartiteTemplateManage', data, {
    headers: { 'Content-Type': ContentTypeEnum.FORM_DATA }
  })

// 重新配置-刷新模板配置失败后使用
export const settingTripartiteTemplateManageByFail = (data: any) =>
  request.post(
    perfix + '/retailContractTemplateManage/settingTripartiteTemplateManageByFail',
    data,
    jsonHeaderConfig
  )

// 不保存并跳转
export const settingTemplateDirectJump = (data: any) =>
  request.post(
    perfix + '/retailContractTemplateManage/settingTripartiteTemplateManageDirectJump',
    data,
    jsonHeaderConfig
  )

// 获取合同模版字段配置
export const getFieldMapping = (data: any) =>
  request.post(perfix + '/retailContractTemplateManage/getFieldMapping', data, jsonHeaderConfig)

// 保存合同模板字段映射
export const saveFieldMapping = (data: any) =>
  request.post(perfix + '/retailContractTemplateManage/saveFieldMapping', data, jsonHeaderConfig)

// 合同模板启用、禁用
export const enableTemplate = (data: any) =>
  request.post(
    perfix + '/retailContractTemplateManage/updateContractTemplateStatus',
    data,
    jsonHeaderConfig
  )

// 删除合同模板
export const deleteTemplate = (data: any) =>
  request.post(
    perfix + '/retailContractTemplateManage/deleteContractTemplate',
    data,
    jsonHeaderConfig
  )

// 查询合同是否可编辑
export const checkTemplateEditable = (data: any) =>
  request.post(
    perfix + '/retailContractTemplateManage/checkContractSignIsOk',
    data,
    jsonHeaderConfig
  )

// 获取已启用的合同模板列表
export const getContractTemplate = () =>
  request.post(
    perfix + '/retailContractTemplateManage/getContractTemplateList',
    null,
    jsonHeaderConfig
  )

// 获取关联业务对象可选-业务字段映射
export const getBusinessFieldMapList = (data: any) =>
  request.post(
    perfix + '/retailContractTemplateManage/getBusinessFieldMapList',
    data,
    jsonHeaderConfig
  )

/**
 * 授权相关
 * */

// 查询合同模板授权-分页数据
export const getAuthorizationPage = (data: any) =>
  request.post(
    perfix + '/retailContractTemplateAuthorization/getAuthorizationPage',
    data,
    jsonHeaderConfig
  )

// 添加授权人员
export const addAuthorization = (data: any) =>
  request.post(
    perfix + '/retailContractTemplateAuthorization/addAuthorization',
    data,
    jsonHeaderConfig
  )

// 清空授权人员
export const clearAllAuthorization = (data: any) =>
  request.post(
    perfix + '/retailContractTemplateAuthorization/clearAllAuthorization',
    data,
    jsonHeaderConfig
  )

// 删除授权人员
export const deleteAuthorization = (data: any) =>
  request.post(
    perfix + '/retailContractTemplateAuthorization/deleteAuthorization',
    data,
    jsonHeaderConfig
  )

// 查询AI话术模板下拉选项
export const getScriptTemplateIdList = (data: any) =>
  request.post('/crm/sign/template/page', data, jsonHeaderConfig)

// 校验是否购买AI面签功能
export const checkBuyAI = (data: any) =>
  request.get('/admin/tenant/checkAppAuth', data, jsonHeaderConfig)

// 查询字段映射Paas
export const getBusinessFieldMapListByPaas = (data: any) =>
  request.post(
    perfix + '/retailContractTemplateManage/getBusinessFieldMapListByPaas',
    data,
    jsonHeaderConfig
  )
